module.exports = __webpack_public_path__ + "img/qt.d7cf166b.png";